module.exports = __webpack_public_path__ + "static/media/6.12.1f4562c8.png";